import {
  SET_SUPPLIER_RETURNS,
  SET_SUPPLIER_RETURNS_FAILED,
  SET_SUPPLIER_RETURNS_LOADING,
  SET_SUPPLIER_RETURN_DOCUMENT,
  SET_WE_OWE,
} from '../actions/types';

const initialState = {
  isLoading: false,
  loadFailed: false,
  returns: [],
  balance: null,
  document: null,
};

export default function supplierReturnReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case SET_SUPPLIER_RETURNS_LOADING:
      return { ...state, isLoading: true, loadFailed: false, returns: [] };
    case SET_SUPPLIER_RETURNS:
      return { ...state, returns: payload, isLoading: false, loadFailed: false };
    case SET_SUPPLIER_RETURNS_FAILED:
      return { ...state, returns: [], isLoading: false, loadFailed: true };
    case SET_WE_OWE:
      return { ...state, balance: payload };
    case SET_SUPPLIER_RETURN_DOCUMENT:
      return { ...state, document: payload };
    default:
      return state;
  }
}
